
import { defineComponent, onUnmounted, ref } from 'vue';
import { useStore } from '@/store';

import { MenuIcon, XIcon } from '@heroicons/vue/solid';
import { useRouter } from 'vue-router';

export default defineComponent({
    name: 'NavTop',
    components: {
        MenuIcon,
        XIcon,
    },
    setup() {
        const router = useRouter();
        const store = useStore();

        const showBurger = ref(false);
        const visible = ref(true);
        const opaque = ref(false);
        const open = ref(false);

        const unsubscribe = store.subscribe((mutation) => {
            if (mutation.type == 'nav/setTransparent') {
                opaque.value = false;
            } else if (mutation.type == 'nav/setOpaque') {
                opaque.value = true;
            } else if (mutation.type == 'nav/hide') {
                visible.value = false;
            } else if (mutation.type == 'nav/show') {
                visible.value = true;
            } else if (mutation.type == 'nav/hideBurger') {
                showBurger.value = false;
            } else if (mutation.type == 'nav/showBurger') {
                showBurger.value = true;
            }
        });

        const toggleSwipeout = () => {
            open.value = !open.value;
        };

        const closeAndGoto = (to: string) => {
            open.value = false;
            router.push(to);
        };

        onUnmounted(() => {
            unsubscribe();
        });

        return {
            toggleSwipeout,
            closeAndGoto,
            showBurger,
            visible,
            opaque,
            open,
        };
    },
});
